import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

$(function() {
    $(".bl-heroslider").each(function() {
        initBlock($(this));
    });
});

function initBlock($bl) {
    initSwiper($bl);
}

function initSwiper($bl) {
    const $pagination = $bl.find(".swiper-pagination");

    const swiper = new Swiper($bl.find(".swiper").get(0), {
      loop: true,
      //rewind: true,
      autoHeight: false,
      
      pagination: {
        el: $pagination.get(0),
        clickable: true
      },

      /*
      navigation: {
        prevEl: $ctrswipernavigation.find(".icon-arrowleft").get(0),
        nextEl: $ctrswipernavigation.find(".icon-arrowright").get(0),
      },
      */

      speed: 1500,
      autoplay: {
        delay: 4000
      }
    });
}

